import { useLayoutEffect } from "react";

type usePlayerTeleportType = {
  element: HTMLElement | null,
  isMini: boolean,
  mini: HTMLElement | null,
  slot: HTMLElement | null,
  base: HTMLElement | null,
  baseMini?: HTMLElement | null,
};

export const usePlayerTeleport =({
  element,
  isMini,
  mini,
  slot,
  base,
  baseMini = null,
}: usePlayerTeleportType)=> {
  useLayoutEffect(() => {
    if (!element) return;

    let desired: HTMLElement | null;

    if (isMini) {
      desired = mini ?? baseMini ?? null;
      if (!desired) return;
    } else {
      desired = slot ?? base ?? baseMini ?? null;
      if (!desired) return;
    }

    if (!desired.contains(element)) {
      desired.appendChild(element);
    }
  }, [
    element,
    isMini,
    mini,
    slot,
    base,
    baseMini,
  ]);
};
